import React from 'react';
import { ShoppingCart, Receipt, MessageCircle, Globe, Truck, Users, Package, Check, X } from 'lucide-react';

export const PLAN_MODULES = [
  { key: 'pdv', label: 'PDV & Frente de Caixa', desc: 'Caixa rápido, balança, estoque e relatórios', icon: ShoppingCart, always: true },
  { key: 'fiscal', label: 'Emissor NFC-e / NF-e', desc: 'Homologado SEFAZ com contingência', icon: Receipt, always: true },
  { key: 'whatsapp', label: 'WhatsApp Bot com IA', desc: 'Atende e anota pedidos 24h', icon: MessageCircle },
  { key: 'online', label: 'Catálogo Online & Pedidos', desc: 'Sua loja virtual com link próprio', icon: Globe },
  { key: 'marketplace', label: 'Marketplaces', desc: 'iFood, Rappi, Shopee, Mercado Livre…', icon: Truck },
];

export const planHasModule = (plan, m) => m.always || !!(plan?.modules && plan.modules[m.key]);

const limite = (v, sing, plur) => (v === -1 || v == null ? `${plur.charAt(0).toUpperCase() + plur.slice(1)} ilimitados` : `Até ${v} ${v === 1 ? sing : plur}`);

export const PlanModulesList = ({ plan, dark = false, compact = false, showLimits = true }) => {
  const on = dark ? 'text-slate-200' : 'text-slate-800';
  const off = dark ? 'text-slate-600' : 'text-slate-400';
  const sub = dark ? 'text-slate-500' : 'text-slate-500';
  return (
    <ul className={compact ? 'space-y-1.5' : 'space-y-2.5'} data-testid={`plan-modules-${plan?.id || 'x'}`}>
      {PLAN_MODULES.map((m) => {
        const has = planHasModule(plan, m);
        return (
          <li key={m.key} className={`flex items-start gap-2 ${has ? on : off} ${has ? '' : 'line-through decoration-slate-500/50'}`} data-testid={`plan-module-${plan?.id || 'x'}-${m.key}-${has ? 'on' : 'off'}`}>
            {has ? <Check className="w-4 h-4 text-emerald-500 flex-shrink-0 mt-0.5" /> : <X className={`w-4 h-4 flex-shrink-0 mt-0.5 ${off}`} />}
            <span className="text-sm leading-tight">
              <span className="font-medium">{m.label}</span>
              {!compact && has && <span className={`block text-xs ${sub} no-underline`}>{m.desc}</span>}
            </span>
          </li>
        );
      })}
      {showLimits && (
        <>
          <li className={`flex items-center gap-2 text-sm ${on} pt-2 border-t ${dark ? 'border-slate-800' : 'border-slate-100'}`}>
            <Users className="w-4 h-4 text-amber-500 flex-shrink-0" />{limite(plan?.max_users, 'usuário', 'usuários')}
          </li>
          <li className={`flex items-center gap-2 text-sm ${on}`}>
            <Package className="w-4 h-4 text-amber-500 flex-shrink-0" />{limite(plan?.max_products, 'produto', 'produtos')}
          </li>
        </>
      )}
    </ul>
  );
};
